/* tslint:disable */
/* eslint-disable */
// Generated using typescript-generator version 2.34.976 on 2023-02-24 09:55:51.
import { onboardingAPIService } from "./onboardingAPIService";

export class AdminConstant {
  constructor(data: AdminConstant) { }
}
export class ApplicationConstants {
  constructor(data: ApplicationConstants) { }
}

export class CreateCustomerAppRequest {
  appName: string;
  appDescription: string;

  constructor(data: CreateCustomerAppRequest) {
    this.appName = data.appName;
    this.appDescription = data.appDescription;
  }
}

export class CreateOrUpdateCustomerRequest {
  customerName: string;
  abbreviation: string;
  profileURL: string | null;
  commissionPercentage: number;
  adminFees: number;
  contactPersonPhoneNumber: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  contactPersonEmail: string;
  businessAddress1: string;
  businessAddress2: string;
  businessEmail: string;
  businessContactNumber: string;
  state: string;
  country: string;
  zipCode: string;
  platformServiceIds: number[];
  subscriptionPlanId: string;
  revenueShareType: string;
  chargePerActiveWallet: string;
  daysAfterWalletDeactivationToCharge: number;

  constructor(data: CreateOrUpdateCustomerRequest) {
    this.customerName = data.customerName;
    this.abbreviation = data.abbreviation;
    this.profileURL = data.profileURL;
    this.commissionPercentage = data.commissionPercentage;
    this.adminFees = data.adminFees;
    this.contactPersonPhoneNumber = data.contactPersonPhoneNumber;
    this.contactPersonFirstName = data.contactPersonFirstName;
    this.contactPersonLastName = data.contactPersonLastName;
    this.contactPersonEmail = data.contactPersonEmail;
    this.businessAddress1 = data.businessAddress1;
    this.businessAddress2 = data.businessAddress2;
    this.businessEmail = data.businessEmail;
    this.businessContactNumber = data.businessContactNumber;
    this.state = data.state;
    this.country = data.country;
    this.zipCode = data.zipCode;
    this.platformServiceIds = data.platformServiceIds;
    this.subscriptionPlanId = data.subscriptionPlanId;
    this.revenueShareType = data.revenueShareType;
    this.chargePerActiveWallet = data.chargePerActiveWallet;
    this.daysAfterWalletDeactivationToCharge = data.daysAfterWalletDeactivationToCharge;
  }
}

export class CreateOrUpdateGameRequest {
  gameId?: string | null;
  gameName: string;
  gameRules: string[];

  constructor(data: CreateOrUpdateGameRequest) {
    this.gameId = data.gameId;
    this.gameName = data.gameName;
    this.gameRules = data.gameRules;
  }
}

export class CreateSubscriptionPlanRequest {
  name: string;
  amount: number;
  durationInDays: number;

  constructor(data: CreateSubscriptionPlanRequest) {
    this.name = data.name;
    this.amount = data.amount;
    this.durationInDays = data.durationInDays;
  }
}

export class CreateUserRequest {
  userFirstName: string;
  userLastName: string;
  userEmail: string;
  userReferenceId: string;
  customerId: string;
  customerAppId: string;
  initialTopUp: boolean;
  initialTokens: number;

  constructor(data: CreateUserRequest) {
    this.userFirstName = data.userFirstName;
    this.userLastName = data.userLastName;
    this.userEmail = data.userEmail;
    this.userReferenceId = data.userReferenceId;
    this.customerId = data.customerId;
    this.customerAppId = data.customerAppId;
    this.initialTopUp = data.initialTopUp;
    this.initialTokens = data.initialTokens;
  }
}

export class CustomerCredentialResponse {
  clientId: string;
  secretKey: string;

  constructor(data: CustomerCredentialResponse) {
    this.clientId = data.clientId;
    this.secretKey = data.secretKey;
  }
}

export class CustomerReportResponse {
  maxCustomer: number;
  minCustomer: number;
  customerReportsDTOS: CustomerReportsDTO[];

  constructor(data: CustomerReportResponse) {
    this.maxCustomer = data.maxCustomer;
    this.minCustomer = data.minCustomer;
    this.customerReportsDTOS = data.customerReportsDTOS;
  }
}

export class LoginRequest {
  userName: string;
  password: string;

  constructor(data: LoginRequest) {
    this.userName = data.userName;
    this.password = data.password;
  }
}

export class LoginResponse {
  customerId: string;
  accessToken: string;
  accessTokenId: string;
  accessTokenStatus: ApiKeyStatusEnums;
  expireAt: Date;
  role: string;
  createdOn: Date;
  lastModifiedOn: Date;
  reset: boolean;
  is2FAEnabled: boolean;
  themeMode: string;

  constructor(data: LoginResponse) {
    this.customerId = data.customerId;
    this.accessToken = data.accessToken;
    this.accessTokenId = data.accessTokenId;
    this.accessTokenStatus = data.accessTokenStatus;
    this.expireAt = data.expireAt;
    this.role = data.role;
    this.createdOn = data.createdOn;
    this.lastModifiedOn = data.lastModifiedOn;
    this.reset = data.reset;
    this.is2FAEnabled = data.is2FAEnabled;
    this.themeMode = data.themeMode;
  }
}
export class OTPVerificationResponse {
  isOtpValid: boolean;
  message: string;
  backupCodes: BackupCode[];
  themeMode: string;

  constructor(data: OTPVerificationResponse) {
    this.isOtpValid = data.isOtpValid;
    this.message = data.message;
    this.backupCodes = data.backupCodes;
    this.themeMode = data.themeMode;
  }
}

export class BackupCodeVerificationResponse {
  verifyBackupCode: boolean;
  message: string;
  themeMode: string;

  constructor(data: BackupCodeVerificationResponse) {
    this.verifyBackupCode = data.verifyBackupCode;
    this.message = data.message;
    this.themeMode = data.themeMode;
  }
}
export class BackupCode {
  backupCode: string;
  isUsed: boolean;

  constructor(data: BackupCode) {
    this.backupCode = data.backupCode;
    this.isUsed = data.isUsed;
  }
}
export class PaginationRequest {
  currentPage: number;
  itemPerPage: number;
  sortingOrder?: string;
  sortingField?: string;

  constructor(data: PaginationRequest) {
    this.currentPage = data.currentPage;
    this.itemPerPage = data.itemPerPage;
    this.sortingOrder = data.sortingOrder;
    this.sortingField = data.sortingField;
  }
}

export class SearchReportsRequest {
  filters: Filters[];
  toDate: string | undefined | null;
  fromDate: string | undefined | null;

  constructor(data: SearchReportsRequest) {
    this.filters = data.filters;
    this.toDate = data.toDate;
    this.fromDate = data.fromDate;
  }
}

export class UserReportResponse {
  maxUser: number;
  minUser: number;
  userReportsDTOList: UserReportsDTO[];

  constructor(data: UserReportResponse) {
    this.maxUser = data.maxUser;
    this.minUser = data.minUser;
    this.userReportsDTOList = data.userReportsDTOList;
  }
}

export class VerifyUserLocationRequest {
  deviceIp: string;
  location: LocationVO;

  constructor(data: VerifyUserLocationRequest) {
    this.deviceIp = data.deviceIp;
    this.location = data.location;
  }
}

export interface AppIdAndAppName {
  appName: string;
  appId: string;
}

export class ApiKeyStatusDTO implements Serializable {
  id: number;
  apiKeyId: string;
  status: boolean;

  constructor(data: ApiKeyStatusDTO) {
    this.id = data.id;
    this.apiKeyId = data.apiKeyId;
    this.status = data.status;
  }
}

export class CustomerAppsDTO {
  commissionPercentage: number;
  adminFees: number;
  customerId: string;
  customerName: string;
  customerAppsVO: CustomerAppsVO[];

  constructor(data: CustomerAppsDTO) {
    this.commissionPercentage = data.commissionPercentage;
    this.adminFees = data.adminFees;
    this.customerId = data.customerId;
    this.customerName = data.customerName;
    this.customerAppsVO = data.customerAppsVO;
  }
}

export class CustomerDTO {
  customerId: string;
  customerName: string;
  abbreviation: string;
  profileURL: string;
  revenueShare: number;
  chargePerActiveWallet: string;
  adminFees: number;
  status: boolean;
  contactPersonPhoneNumber: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  contactPersonEmail: string;
  businessAddress1: string;
  businessAddress2: string;
  businessEmail: string;
  businessContactNumber: string;
  state: State;
  country: Country;
  zipCode: string;
  createdBy: string;
  subscriptionPlan: SubscriptionPlanVO;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;
  revenueShareType: string;

  constructor(data: CustomerDTO) {
    this.customerId = data.customerId;
    this.customerName = data.customerName;
    this.abbreviation = data.abbreviation;
    this.profileURL = data.profileURL;
    this.revenueShare = data.revenueShare;
    this.chargePerActiveWallet = data.chargePerActiveWallet;
    this.adminFees = data.adminFees;
    this.status = data.status;
    this.contactPersonPhoneNumber = data.contactPersonPhoneNumber;
    this.contactPersonFirstName = data.contactPersonFirstName;
    this.contactPersonLastName = data.contactPersonLastName;
    this.contactPersonEmail = data.contactPersonEmail;
    this.businessAddress1 = data.businessAddress1;
    this.businessAddress2 = data.businessAddress2;
    this.businessEmail = data.businessEmail;
    this.businessContactNumber = data.businessContactNumber;
    this.state = data.state;
    this.country = data.country;
    this.zipCode = data.zipCode;
    this.createdBy = data.createdBy;
    this.subscriptionPlan = data.subscriptionPlan;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
    this.revenueShareType = data.revenueShareType;
  }
}

export class GameDTO {
  gameId?: string | null;
  gameName: string;
  gameRules: string[];

  constructor(data: CreateOrUpdateGameRequest) {
    this.gameId = data.gameId;
    this.gameName = data.gameName;
    this.gameRules = data.gameRules;
  }
}

export class CustomerReportsDTO {
  totalCustomer: number;
  totalCustomerApp: number;
  month: string;

  constructor(data: CustomerReportsDTO) {
    this.totalCustomer = data.totalCustomer;
    this.totalCustomerApp = data.totalCustomerApp;
    this.month = data.month;
  }
}

export class Filters {
  name: string;
  value: string;

  constructor(data: Filters) {
    this.name = data.name;
    this.value = data.value;
  }
}

export class UserDTO {
  id: string;
  userName: string;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userRole: string;
  customerId: string;
  customerName: string;
  userReferenceId: string;
  status: UserStatus;
  appId: string;
  walletId: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: UserDTO) {
    this.id = data.id;
    this.userName = data.userName;
    this.userEmail = data.userEmail;
    this.userFirstName = data.userFirstName;
    this.userLastName = data.userLastName;
    this.userRole = data.userRole;
    this.customerId = data.customerId;
    this.customerName = data.customerName;
    this.userReferenceId = data.userReferenceId;
    this.status = data.status;
    this.appId = data.appId;
    this.walletId = data.walletId;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class UserReportsDTO {
  activeTotalUsers: number;
  inactiveTotalUsers: number;
  averageUserPerTenant: number;
  allTotalUsers: number;
  months: string;

  constructor(data: UserReportsDTO) {
    this.activeTotalUsers = data.activeTotalUsers;
    this.inactiveTotalUsers = data.inactiveTotalUsers;
    this.averageUserPerTenant = data.averageUserPerTenant;
    this.allTotalUsers = data.allTotalUsers;
    this.months = data.months;
  }
}

export class ApiKeyDetailsVO implements Serializable {
  apiKeyDetailId: string;
  customerAppId: string;
  apiKey: string;
  apiKeyId: string;
  status: ApiKeyStatusEnums;
  createdBy: string;
  expireAt: Date;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: ApiKeyDetailsVO) {
    this.apiKeyDetailId = data.apiKeyDetailId;
    this.customerAppId = data.customerAppId;
    this.apiKey = data.apiKey;
    this.apiKeyId = data.apiKeyId;
    this.status = data.status;
    this.createdBy = data.createdBy;
    this.expireAt = data.expireAt;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class CountryVO {
  countryId: string;
  countryName: string;

  constructor(data: CountryVO) {
    this.countryId = data.countryId;
    this.countryName = data.countryName;
  }
}

export class CustomerAppProperties {
  appName: string;
  appDescription: string;

  constructor(data: CustomerAppProperties) {
    this.appName = data.appName;
    this.appDescription = data.appDescription;
  }
}

export class CustomerAppsVO {
  customerAppId: string;
  customerId: string;
  appName: string;
  appDescription: string;
  status: boolean;
  keyGenerated: boolean;
  createdBy: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: CustomerAppsVO) {
    this.customerAppId = data.customerAppId;
    this.customerId = data.customerId;
    this.appName = data.appName;
    this.appDescription = data.appDescription;
    this.status = data.status;
    this.keyGenerated = data.keyGenerated;
    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class GameVO {
  gameId?: string | null;
  gameName: string;
  gameRules: string[];

  constructor(data: CreateOrUpdateGameRequest) {
    this.gameId = data.gameId;
    this.gameName = data.gameName;
    this.gameRules = data.gameRules;
  }
}

export class CustomerProperties {
  register: boolean;
  customerName: string;
  profileURL: string;
  commissionPercentage: number;
  adminFees: number;
  contactPersonPhoneNumber: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  contactPersonEmail: string;
  businessAddress1: string;
  businessAddress2: string;
  businessEmail: string;
  businessContactNumber: string;
  state: string;
  country: string;
  zipCode: string;
  passWord: string;
  timeZone: number;
  platformServiceIds: number[];

  constructor(data: CustomerProperties) {
    this.register = data.register;
    this.customerName = data.customerName;
    this.profileURL = data.profileURL;
    this.commissionPercentage = data.commissionPercentage;
    this.adminFees = data.adminFees;
    this.contactPersonPhoneNumber = data.contactPersonPhoneNumber;
    this.contactPersonFirstName = data.contactPersonFirstName;
    this.contactPersonLastName = data.contactPersonLastName;
    this.contactPersonEmail = data.contactPersonEmail;
    this.businessAddress1 = data.businessAddress1;
    this.businessAddress2 = data.businessAddress2;
    this.businessEmail = data.businessEmail;
    this.businessContactNumber = data.businessContactNumber;
    this.state = data.state;
    this.country = data.country;
    this.zipCode = data.zipCode;
    this.passWord = data.passWord;
    this.timeZone = data.timeZone;
    this.platformServiceIds = data.platformServiceIds;
  }
}

export class PlatformServicesVO {
  serviceId: number;
  name: string;
  description: string;
  endPoint: string;

  constructor(data: PlatformServicesVO) {
    this.serviceId = data.serviceId;
    this.name = data.name;
    this.description = data.description;
    this.endPoint = data.endPoint;
  }
}

export class StateVO {
  stateId: string;
  countryId: string;
  stateName: string;
  zipCode: string;
  stateStatus: boolean;

  constructor(data: StateVO) {
    this.stateId = data.stateId;
    this.countryId = data.countryId;
    this.stateName = data.stateName;
    this.zipCode = data.zipCode;
    this.stateStatus = data.stateStatus;
  }
}

export class SubscriptionPlanVO {
  subscriptionPlanId: string;
  name: string;
  amount: number;
  status: boolean;
  createdBy: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;
  durationInDays: number;

  constructor(data: SubscriptionPlanVO) {
    this.subscriptionPlanId = data.subscriptionPlanId;
    this.name = data.name;
    this.amount = data.amount;
    this.status = data.status;
    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
    this.durationInDays = data.durationInDays;
  }
}

export class TimeZonesVO {
  timeZoneId: number;
  timeZoneName: string;

  constructor(data: TimeZonesVO) {
    this.timeZoneId = data.timeZoneId;
    this.timeZoneName = data.timeZoneName;
  }
}

export class UserAccessSessionVo implements Serializable {
  accessDetailId: string;
  customerAppId: string;
  accessKey: string;
  accessKeyId: string;
  accessTokenStatus: ApiKeyStatusEnums;
  createdBy: string;
  expireAt: Date;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: UserAccessSessionVo) {
    this.accessDetailId = data.accessDetailId;
    this.customerAppId = data.customerAppId;
    this.accessKey = data.accessKey;
    this.accessKeyId = data.accessKeyId;
    this.accessTokenStatus = data.accessTokenStatus;
    this.createdBy = data.createdBy;
    this.expireAt = data.expireAt;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class UserVO {
  id: string;
  userName: string;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userRoles: UserRoles;
  customerMaster: CustomerMaster;
  customerAppId: string;
  userReferenceId: string;
  password: string;
  status: boolean;
  createdBy: string;
  updatedBy: string;

  constructor(data: UserVO) {
    this.id = data.id;
    this.userName = data.userName;
    this.userEmail = data.userEmail;
    this.userFirstName = data.userFirstName;
    this.userLastName = data.userLastName;
    this.userRoles = data.userRoles;
    this.customerMaster = data.customerMaster;
    this.customerAppId = data.customerAppId;
    this.userReferenceId = data.userReferenceId;
    this.password = data.password;
    this.status = data.status;
    this.createdBy = data.createdBy;
    this.updatedBy = data.updatedBy;
  }
}

export class BaseEntity {
  createdBy: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: BaseEntity) {
    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class ApiKeyDetails extends BaseEntity {
  apiKeyDetailId: string;
  customerApps: CustomerApps;
  apiKey: string;
  apiKeyId: string;
  expireAt: Date;
  status: ApiKeyStatusEnums;

  constructor(data: ApiKeyDetails) {
    super(data);
    this.apiKeyDetailId = data.apiKeyDetailId;
    this.customerApps = data.customerApps;
    this.apiKey = data.apiKey;
    this.apiKeyId = data.apiKeyId;
    this.expireAt = data.expireAt;
    this.status = data.status;
  }
}

export class Country {
  countryId: string;
  countryName: string;

  constructor(data: Country) {
    this.countryId = data.countryId;
    this.countryName = data.countryName;
  }
}

export class CustomerApps extends BaseEntity {
  customerAppId: string;
  apiKeyId: string;
  appName: string;
  appDescription: string;
  status: boolean;

  constructor(data: CustomerApps) {
    super(data);
    this.customerAppId = data.customerAppId;
    this.apiKeyId = data.apiKeyId;
    this.appName = data.appName;
    this.appDescription = data.appDescription;
    this.status = data.status;
  }
}

export class CustomerBilling extends BaseEntity {
  customerBillingId: string;
  customerId: string;
  subscriptionPlanId: string;
  startDate: Date;
  lastInvoiceDate: Date;
  nextInvoiceDate: Date;
  invoiceDuration: number;

  constructor(data: CustomerBilling) {
    super(data);
    this.customerBillingId = data.customerBillingId;
    this.customerId = data.customerId;
    this.subscriptionPlanId = data.subscriptionPlanId;
    this.startDate = data.startDate;
    this.lastInvoiceDate = data.lastInvoiceDate;
    this.nextInvoiceDate = data.nextInvoiceDate;
    this.invoiceDuration = data.invoiceDuration;
  }
}

export class CustomerDetails extends BaseEntity {
  customerDetailsId: string;
  contactPersonPhoneNumber: string;
  contactPersonFirstName: string;
  contactPersonLastName: string;
  contactPersonEmail: string;
  businessAddress1: string;
  businessAddress2: string;
  businessEmail: string;
  businessContactNumber: string;
  state: State;
  country: Country;
  zipCode: string;

  constructor(data: CustomerDetails) {
    super(data);
    this.customerDetailsId = data.customerDetailsId;
    this.contactPersonPhoneNumber = data.contactPersonPhoneNumber;
    this.contactPersonFirstName = data.contactPersonFirstName;
    this.contactPersonLastName = data.contactPersonLastName;
    this.contactPersonEmail = data.contactPersonEmail;
    this.businessAddress1 = data.businessAddress1;
    this.businessAddress2 = data.businessAddress2;
    this.businessEmail = data.businessEmail;
    this.businessContactNumber = data.businessContactNumber;
    this.state = data.state;
    this.country = data.country;
    this.zipCode = data.zipCode;
  }
}

export class CustomerMaster extends BaseEntity {
  customerId: string;
  customerName: string;
  profileURL: string;
  clientId: string;
  customerDetails: CustomerDetails;
  platformServices: PlatformServices[];
  clientSecretKey: string;
  commissionPercentage: number;
  adminFees: number;
  status: boolean;

  constructor(data: CustomerMaster) {
    super(data);
    this.customerId = data.customerId;
    this.customerName = data.customerName;
    this.profileURL = data.profileURL;
    this.clientId = data.clientId;
    this.customerDetails = data.customerDetails;
    this.platformServices = data.platformServices;
    this.clientSecretKey = data.clientSecretKey;
    this.commissionPercentage = data.commissionPercentage;
    this.adminFees = data.adminFees;
    this.status = data.status;
  }
}

export class CustomerServiceMapping {
  customerId: string;
  serviceId: string;

  constructor(data: CustomerServiceMapping) {
    this.customerId = data.customerId;
    this.serviceId = data.serviceId;
  }
}

export class CustomerSubscription extends BaseEntity {
  id: string;
  customerId: string;
  subscriptionPlanId: string;
  startDate: Date;
  endDate: Date;
  status: boolean;
  autoRenew: boolean;

  constructor(data: CustomerSubscription) {
    super(data);
    this.id = data.id;
    this.customerId = data.customerId;
    this.subscriptionPlanId = data.subscriptionPlanId;
    this.startDate = data.startDate;
    this.endDate = data.endDate;
    this.status = data.status;
    this.autoRenew = data.autoRenew;
  }
}

export class GidxUsers extends BaseEntity {
  id: string;
  userId: string;
  merchantCustomerId: string;
  merchantSessionID: string;
  merchantTransactionID: string;
  merchantOrderID: string;
  sessionRequestId: string;
  location: LocationVO;
  verifyStatus: boolean;
  firstVerifiedAt: Date;
  lastVerifiedAt: Date;

  constructor(data: GidxUsers) {
    super(data);
    this.id = data.id;
    this.userId = data.userId;
    this.merchantCustomerId = data.merchantCustomerId;
    this.merchantSessionID = data.merchantSessionID;
    this.merchantTransactionID = data.merchantTransactionID;
    this.merchantOrderID = data.merchantOrderID;
    this.sessionRequestId = data.sessionRequestId;
    this.location = data.location;
    this.verifyStatus = data.verifyStatus;
    this.firstVerifiedAt = data.firstVerifiedAt;
    this.lastVerifiedAt = data.lastVerifiedAt;
  }
}

export class PlatformServices extends BaseEntity {
  serviceId: number;
  customerMaster: CustomerMaster[];
  name: string;
  description: string;
  endPoint: string;
  status: boolean;

  constructor(data: PlatformServices) {
    super(data);
    this.serviceId = data.serviceId;
    this.customerMaster = data.customerMaster;
    this.name = data.name;
    this.description = data.description;
    this.endPoint = data.endPoint;
    this.status = data.status;
  }
}

export class State {
  stateId: string;
  countryId: string;
  stateName: string;
  zipCode: string;
  stateStatus: boolean;

  constructor(data: State) {
    this.stateId = data.stateId;
    this.countryId = data.countryId;
    this.stateName = data.stateName;
    this.zipCode = data.zipCode;
    this.stateStatus = data.stateStatus;
  }
}

export class SubscriptionPlan extends BaseEntity {
  subscriptionPlanId: string;
  name: string;
  amount: number;
  status: boolean;
  durationInDays: number;

  constructor(data: SubscriptionPlan) {
    super(data);
    this.subscriptionPlanId = data.subscriptionPlanId;
    this.name = data.name;
    this.amount = data.amount;
    this.status = data.status;
    this.durationInDays = data.durationInDays;
  }
}

export class TimeZones {
  timeZoneId: number;
  timeZoneName: string;

  constructor(data: TimeZones) {
    this.timeZoneId = data.timeZoneId;
    this.timeZoneName = data.timeZoneName;
  }
}

export class UserRoles {
  userRoleId: number;
  roleName: string;
  status: boolean;
  description: string;

  constructor(data: UserRoles) {
    this.userRoleId = data.userRoleId;
    this.roleName = data.roleName;
    this.status = data.status;
    this.description = data.description;
  }
}

export class UserSessions extends BaseEntity {
  userSessionId: string;
  accessTokenId: string;
  accessToken: string;
  users: Users;
  customerMaster: CustomerMaster;
  status: ApiKeyStatusEnums;
  expireAt: Date;

  constructor(data: UserSessions) {
    super(data);
    this.userSessionId = data.userSessionId;
    this.accessTokenId = data.accessTokenId;
    this.accessToken = data.accessToken;
    this.users = data.users;
    this.customerMaster = data.customerMaster;
    this.status = data.status;
    this.expireAt = data.expireAt;
  }
}

export class Users extends BaseEntity {
  userId: string;
  userName: string;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userRoles: UserRoles;
  customerMaster: CustomerMaster;
  customerAppId: string;
  userReferenceId: string;
  walletId: string;
  password: string;
  status: boolean;
  reset: boolean;

  constructor(data: Users) {
    super(data);
    this.userId = data.userId;
    this.userName = data.userName;
    this.userEmail = data.userEmail;
    this.userFirstName = data.userFirstName;
    this.userLastName = data.userLastName;
    this.userRoles = data.userRoles;
    this.customerMaster = data.customerMaster;
    this.customerAppId = data.customerAppId;
    this.userReferenceId = data.userReferenceId;
    this.walletId = data.walletId;
    this.password = data.password;
    this.status = data.status;
    this.reset = data.reset;
  }
}

export class PaymentDetailVO {
  merchantSessionID: string;
  merchantTransactionID: string;
  accessToken: string;

  constructor(data: PaymentDetailVO) {
    this.merchantSessionID = data.merchantSessionID;
    this.merchantTransactionID = data.merchantTransactionID;
    this.accessToken = data.accessToken;
  }
}

export class SearchingTransactionResponseDTO {
  customerId: string;
  appId: string;
  walletId: string;
  transactionSubType: TransactionSubType;
  totalTokens: number;

  constructor(data: SearchingTransactionResponseDTO) {
    this.customerId = data.customerId;
    this.appId = data.appId;
    this.walletId = data.walletId;
    this.transactionSubType = data.transactionSubType;
    this.totalTokens = data.totalTokens;
  }
}

export enum UserStatus {
  OPEN = "OPEN",
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  PENDING = "PENDING"
}

export class UserInfoDTO {
  id: string;
  userName: string;
  userEmail: string;
  userFirstName: string;
  userLastName: string;
  userRole: string;
  customerId: string;
  userReferenceId: string;
  status: UserStatus;
  appId: string;
  walletId: string;
  lastModifiedOn: Date;

  constructor(data: UserInfoDTO) {
    this.id = data.id;
    this.userName = data.userName;
    this.userEmail = data.userEmail;
    this.userFirstName = data.userFirstName;
    this.userLastName = data.userLastName;
    this.userRole = data.userRole;
    this.customerId = data.customerId;
    this.userReferenceId = data.userReferenceId;
    this.status = data.status;
    this.appId = data.appId;
    this.walletId = data.walletId;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class WalletDTO implements Serializable {
  walletId: string;
  userId: string;
  customerId: string;
  appId: string;
  walletType: string;
  gidxVerified: boolean;
  totalToken: number;
  blockedToken: number;
  availableToken: number;
  status: boolean;
  redeemable: boolean;
  createdBy: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: WalletDTO) {
    this.walletId = data.walletId;
    this.userId = data.userId;
    this.customerId = data.customerId;
    this.appId = data.appId;
    this.walletType = data.walletType;
    this.gidxVerified = data.gidxVerified;
    this.totalToken = data.totalToken;
    this.blockedToken = data.blockedToken;
    this.availableToken = data.availableToken;
    this.status = data.status;
    this.redeemable = data.redeemable;
    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class GetAdminFeesCalculationResponse {
  appId: string;
  totalAPICalls: number;
  totalTokens: number;
  totalAmountInDollar: number;

  constructor(data: GetAdminFeesCalculationResponse) {
    this.appId = data.appId;
    this.totalAPICalls = data.totalAPICalls;
    this.totalTokens = data.totalTokens;
    this.totalAmountInDollar = data.totalAmountInDollar;
  }
}

export class BaseResponse {
  type: "ErrorResponse" | "SuccessResponse" | "PageResponseObject";
  status: boolean;
  responseCode: number;

  constructor(data: BaseResponse) {
    this.type = data.type;
    this.status = data.status;
    this.responseCode = data.responseCode;
  }
}

export class ErrorResponse extends BaseResponse {
  type: "ErrorResponse" = "ErrorResponse";
  errorCode: number;
  errorMsg: string;
  errors: string[];

  constructor(data: ErrorResponse) {
    super(data);
    this.errorCode = data.errorCode;
    this.errorMsg = data.errorMsg;
    this.errors = data.errors;
  }
}

export class SuccessResponse<T> extends BaseResponse {
  type: "SuccessResponse" | "PageResponseObject" = "SuccessResponse";
  message: string;
  response: T;

  constructor(data: SuccessResponse<T>) {
    super(data);
    this.message = data.message;
    this.response = data.response;
  }
}

export class PageResponseObject<T> extends SuccessResponse<T> {
  type: "PageResponseObject" = "PageResponseObject";
  totalRecords: number;
  pageNumber: number;
  pageSize: number;
  sortOrder: SortOrder[];
  filterString: string;
  recordsTotal: number;

  constructor(data: PageResponseObject<T>) {
    super(data);
    this.totalRecords = data.totalRecords;
    this.pageNumber = data.pageNumber;
    this.pageSize = data.pageSize;
    this.sortOrder = data.sortOrder;
    this.filterString = data.filterString;
    this.recordsTotal = data.recordsTotal;
  }
}

export class ResponseBaseBean<T> {
  currentPage: number;
  totalItems: number;
  itemPerPage: number;
  totalPages: number;
  status: number;
  message: string;
  response: T[];

  constructor(data: ResponseBaseBean<T>) {
    this.currentPage = data.currentPage;
    this.totalItems = data.totalItems;
    this.itemPerPage = data.itemPerPage;
    this.totalPages = data.totalPages;
    this.status = data.status;
    this.message = data.message;
    this.response = data.response;
  }
}

export class SortOrder {
  sortFiled: string;
  order: Direction;

  constructor(data: SortOrder) {
    this.sortFiled = data.sortFiled;
    this.order = data.order;
  }
}

export class ApiKeyDetailsCommon implements Serializable {
  apiKeyDetailId: number;
  customerAppId: number;
  apiKey: string;
  apiKeyId: string;
  status: boolean;
  createdBy: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: ApiKeyDetailsCommon) {
    this.apiKeyDetailId = data.apiKeyDetailId;
    this.customerAppId = data.customerAppId;
    this.apiKey = data.apiKey;
    this.apiKeyId = data.apiKeyId;
    this.status = data.status;
    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class Location {
  latitude: number;
  longitude: number;

  constructor(data: Location) {
    this.latitude = data.latitude;
    this.longitude = data.longitude;
  }
}

export class LocationVO {
  latitude: number;
  longitude: number;

  constructor(data: LocationVO) {
    this.latitude = data.latitude;
    this.longitude = data.longitude;
  }
}

export class TokenValidationResponse {
  status: ApiKeyStatusEnums;
  validUpto: Date;
  active: ApiKeyStatusEnums;

  constructor(data: TokenValidationResponse) {
    this.status = data.status;
    this.validUpto = data.validUpto;
    this.active = data.active;
  }
}

export class WalletLedgerVo {
  walletLedgerId: string;
  walletId: string;
  totalToken: number;
  blockedToken: number;
  availableToken: number;
  createdBy: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;

  constructor(data: WalletLedgerVo) {
    this.walletLedgerId = data.walletLedgerId;
    this.walletId = data.walletId;
    this.totalToken = data.totalToken;
    this.blockedToken = data.blockedToken;
    this.availableToken = data.availableToken;
    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
  }
}

export class WalletMasterVo {
  walletId: string;
  userId: string;
  walletType: string;
  gidxVerified: boolean;
  walletLedger: WalletLedgerVo;
  walletCreationStatus: CreationStatus;
  status: boolean;
  createdBy: string;
  createdOn: Date;
  lastModifiedBy: string;
  lastModifiedOn: Date;
  redeem: boolean;

  constructor(data: WalletMasterVo) {
    this.walletId = data.walletId;
    this.userId = data.userId;
    this.walletType = data.walletType;
    this.gidxVerified = data.gidxVerified;
    this.walletLedger = data.walletLedger;
    this.walletCreationStatus = data.walletCreationStatus;
    this.status = data.status;
    this.createdBy = data.createdBy;
    this.createdOn = data.createdOn;
    this.lastModifiedBy = data.lastModifiedBy;
    this.lastModifiedOn = data.lastModifiedOn;
    this.redeem = data.redeem;
  }
}

export class GetCustomerAppDetailsByAppIdsRequest {
  appIds: string[];
  customerIds: string[];

  constructor(data: GetCustomerAppDetailsByAppIdsRequest) {
    this.appIds = data.appIds;
    this.customerIds = data.customerIds;
  }
}

export class WalletChartRequest {
  filters: Filters[];
  toDate: string | undefined | null;
  fromDate: string | undefined | null;
  customerId: string | undefined | null;
  countryId: string | undefined | null;
  stateId: string | undefined | null;

  constructor(data: WalletChartRequest) {
    this.filters = data.filters;
    this.toDate = data.toDate;
    this.fromDate = data.fromDate;
    this.customerId = data.customerId;
    this.countryId = data.countryId;
    this.stateId = data.stateId;
  }
}

export class WalletChartResponse {
  walletTokenResponses: WalletTokenResponse[];
  topUserWalletResponses: TopUserWalletResponse[];
  startingBalance: number;
  endingBalance: number;
  deposits: number;
  withdrawals: number;
  netChanges: number;

  constructor(data: WalletChartResponse) {
    this.walletTokenResponses = data.walletTokenResponses;
    this.topUserWalletResponses = data.topUserWalletResponses;
    this.startingBalance = data.startingBalance;
    this.endingBalance = data.endingBalance;
    this.deposits = data.deposits;
    this.withdrawals = data.withdrawals;
    this.netChanges = data.netChanges;
  }
}

export class WalletTokenResponse {
  month: string;
  totalTokens: number;

  constructor(data: WalletTokenResponse) {
    this.month = data.month;
    this.totalTokens = data.totalTokens;
  }
}

export class TopUserWalletResponse {
  startingTokens: number;
  endingTokens: number;
  userName: string;

  constructor(data: TopUserWalletResponse) {
    this.startingTokens = data.startingTokens;
    this.endingTokens = data.endingTokens;
    this.userName = data.userName;
  }
}

export class IncomeSearchReportsRequest {
  filters: Filters[];
  toDate: string | undefined | null;
  fromDate: string | undefined | null;
  customerIds: string[] | undefined | null;
  countryId: string | undefined | null;
  stateId: string | undefined | null;

  constructor(data: IncomeSearchReportsRequest) {
    this.filters = data.filters;
    this.toDate = data.toDate;
    this.fromDate = data.fromDate;
    this.customerIds = data.customerIds;
    this.countryId = data.countryId;
    this.stateId = data.stateId;
  }
}

export class IncomeReportsResponse {
  totalIncomeResponses: TotalIncomeResponse[];
  topTenantIncomeResponses: TopTenantIncomeResponse[];
  totalIncome: number;
  totalD3Share: number;
  trend: number;
  maximumIncomeDate: string;

  constructor(data: IncomeReportsResponse) {
    this.totalIncomeResponses = data.totalIncomeResponses;
    this.topTenantIncomeResponses = data.topTenantIncomeResponses;
    this.totalIncome = data.totalIncome;
    this.totalD3Share = data.totalD3Share;
    this.trend = data.trend;
    this.maximumIncomeDate = data.maximumIncomeDate;
  }
}

export class TotalIncomeResponse {
  month: string;
  totalIncome: number;
  totalD3Share: number;

  constructor(data: TotalIncomeResponse) {
    this.month = data.month;
    this.totalIncome = data.totalIncome;
    this.totalD3Share = data.totalD3Share;
  }
}

export class TopTenantIncomeResponse {
  totalIncome: number;
  totalD3Share: number;
  customerName: string;

  constructor(data: TopTenantIncomeResponse) {
    this.totalIncome = data.totalIncome;
    this.totalD3Share = data.totalD3Share;
    this.customerName = data.customerName;
  }
}

export class ChallengeChartRequest {
  filters: Filters[];
  toDate: string | undefined | null;
  fromDate: string | undefined | null;
  customerId: string | undefined | null;
  countryId: string | undefined | null;
  stateId: string | undefined | null;
  gameTypeId: string | undefined | null;
  constructor(data: ChallengeChartRequest) {
    this.filters = data.filters;
    this.toDate = data.toDate;
    this.fromDate = data.fromDate;
    this.customerId = data.customerId;
    this.countryId = data.countryId;
    this.stateId = data.stateId;
    this.gameTypeId = data.gameTypeId;
  }
}

export class ChallengeChartResponse {

  totalChallengeResponses: TotalChallengeResponse[];
  topGamesResponses: TopGamesResponse[];
  total: number;
  avgOfMonth: number;
  totalTokens: number;
  tokensOfMonth: number;
  medianWager: number;
  tokensAndChallenge: number;

  constructor(data: ChallengeChartResponse) {
    this.totalChallengeResponses = data.totalChallengeResponses;
    this.topGamesResponses = data.topGamesResponses;
    this.total = data.total;
    this.avgOfMonth = data.avgOfMonth;
    this.totalTokens = data.totalTokens;
    this.tokensOfMonth = data.tokensOfMonth;
    this.medianWager = data.medianWager;
    this.tokensAndChallenge = data.tokensAndChallenge;

  }
}


export class TotalChallengeResponse {
  month: string;
  totalTokens: number;
  totalChallenge: number;

  constructor(data: TotalChallengeResponse) {
    this.month = data.month;
    this.totalTokens = data.totalTokens;
    this.totalChallenge = data.totalChallenge;
  }
}

export class TopGamesResponse {
  game: string;
  customerName: string;
  totalTokens: number;
  totalChallenge: number;

  constructor(data: TopGamesResponse) {
    this.game = data.game;
    this.customerName = data.customerName;
    this.totalTokens = data.totalTokens;
    this.totalChallenge = data.totalChallenge;
  }
}

export class AdminActivityReportResponse {
  eventId: string;
  eventType: string;
  oldValue: { [key: string]: any };
  newValue: { [key: string]: any };
  description: string;
  updatedTimestamp: Date;
  constructor(data: any) {
    this.eventId = data.eventId;
    this.eventType = data.eventType;
    this.oldValue = data.oldValue;
    this.newValue = data.newValue;
    this.description = data.description;
    this.updatedTimestamp = new Date(data.updatedTimestamp);
  }
}
export class AuditEventRequest {
  currentPage: number;
  itemPerPage: number;
  sortingOrder: string;
  sortingField: string;
  customerId: string;
  eventType?: string[];
  fromDate?: string;
  toDate?: string;
  constructor(data: any) {
    this.currentPage = data.currentPage;
    this.itemPerPage = data.itemPerPage;
    this.sortingOrder = data.sortingOrder;
    this.sortingField = data.sortingField;
    this.customerId = data.customerId;
    this.eventType = data.eventType;
    this.fromDate = data.fromDate;
    this.toDate = data.toDate;
  }
}
export class UserCountResponse {
  tenantId: string;
  totalUsers: number;
  inactiveUsers: number;
  openUsers: number;

  constructor(data: UserCountResponse) {
    this.tenantId = data.tenantId;
    this.totalUsers = data.totalUsers;
    this.inactiveUsers = data.inactiveUsers;
    this.openUsers = data.openUsers;
  }
}

export interface Serializable { }

export { RestApplicationClient };
function RestApplicationClient() {
  const httpClient = onboardingAPIService();

  /**
   * HTTP POST /api/v2/admin/apps/details
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.getCustomerAppDetailsByAppIds
   */
  const getCustomerAppDetailsByAppIds = (
    getCustomerAppDetailsByAppIdsRequest: GetCustomerAppDetailsByAppIdsRequest
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/apps/details`,
      data: getCustomerAppDetailsByAppIdsRequest,
    });
  };

  /**
   * HTTP POST /api/v2/admin/apps/names/byIds
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.getCustomerAppsNameByAppIds
   */
  const getCustomerAppsNameByAppIds = (
    appIds: string[]
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/apps/names/byIds`,
      data: appIds,
    });
  };

  /**
   * HTTP POST /api/v2/admin/customers
   * Java method: d3.paas.admin.api.controller.CustomerController.createCustomer
   */
  const createCustomer = (
    createOrUpdateCustomerRequest: CreateOrUpdateCustomerRequest
  ): RestResponse<SuccessResponse<CustomerDTO[]>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers`,
      data: createOrUpdateCustomerRequest,
    });
  };

  /**
   * HTTP POST /api/v2/admin/customers/byIds
   * Java method: d3.paas.admin.api.controller.CustomerController.getCustomerDetailsByIds
   */
  const getCustomerDetailsByIds = (
    customerIds: string[]
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/byIds`,
      data: customerIds,
    });
  };

  /**
   * HTTP GET /api/v2/admin/customers/list
   * Java method: d3.paas.admin.api.controller.CustomerController.getAllCustomerDetails
   */
  const getAllCustomerDetails = (queryParams: {
    status: string;
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
  }): RestResponse<PageResponseObject<CustomerDTO[]>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/customers/list`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/admin/customers/search
   * Java method: d3.paas.admin.api.controller.CustomerController.searchCustomer
   */
  const searchCustomer = (queryParams: {
    status: string;
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    searchTerm: string;
  }): RestResponse<SuccessResponse<PageResponseObject<CustomerDTO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/customers/search`,
      data: queryParams,
    });
  };

  /**
   * HTTP PATCH /api/v2/admin/customers/{customer_app_id}/apps/status
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.updateCustomerAppStatus
   */
  const updateCustomerAppStatus = (
    customer_app_id: string,
    queryParams: { status: boolean }
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "PATCH",
      url: uriEncoding`api/v2/admin/customers/${customer_app_id}/apps/status`,
      data: queryParams,
    });
  };

  /**
   * HTTP POST /api/v2/admin/customers/{customer_id}/apps
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.createCustomerApp
   */
  const createCustomerApp = (
    customer_id: string,
    createCustomerAppRequest: CreateCustomerAppRequest
  ): RestResponse<SuccessResponse<CustomerAppsVO>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps`,
      data: createCustomerAppRequest,
    });
  };

  const createAdminCustomerApp = (
    customer_id: string,
    createCustomerAppRequest: CreateCustomerAppRequest
  ): RestResponse<SuccessResponse<CustomerAppsVO>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/${customer_id}/apps`,
      data: createCustomerAppRequest,
    });
  };

  /**
   * HTTP GET /api/v2/admin/customers/{customer_id}/apps
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.getCustomerAppsById
   */
  const getCustomerAppsById = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    customer_id: string;
  }): RestResponse<SuccessResponse<PageResponseObject<CustomerAppsVO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/customers/${queryParams.customer_id}/apps`,
    });
  };

  const getCustomerGamesByAppId = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    selectedApplicationId: string;
  }): RestResponse<SuccessResponse<PageResponseObject<CustomerAppsVO[]>>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/apps/appTypeDetails?customerAppId=${queryParams.selectedApplicationId}`,
    });
  };

  const getAdminCustomerAppsById = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    customer_id: string;
  }): RestResponse<SuccessResponse<PageResponseObject<CustomerAppsVO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/customers/${queryParams.customer_id}/apps`,
    });
  };

  const getAdminGamesByAppsId = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    selectedApplicationId: string;
  }): RestResponse<SuccessResponse<PageResponseObject<CustomerAppsVO[]>>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/apps/appTypeDetails?customerAppId=${queryParams.selectedApplicationId}`,
    });
  };

  const approveGame = (
    customer_id: string,
    game_id: string,
    queryParams: { status: boolean }
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps/${game_id}/game/status?status=${queryParams.status}`,
    });
  };

  const createGameByAdmin = (
    customer_id: string,
    customer_app_id: string,
    createOrUpdateGameRequest: CreateOrUpdateGameRequest
  ): RestResponse<SuccessResponse<CustomerDTO[]>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps/${customer_app_id}/game`,
      data: createOrUpdateGameRequest,
    });
  };

  const createGame = (
    customer_id: string,
    customer_app_id: string,
    createOrUpdateGameRequest: CreateOrUpdateGameRequest
  ): RestResponse<SuccessResponse<CustomerDTO[]>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/${customer_id}/apps/${customer_app_id}/game`,
      data: createOrUpdateGameRequest,
    });
  };

  const updateGameByAdmin = (
    customer_id: string,
    game_id: string,
    createOrUpdateGameRequest: CreateOrUpdateGameRequest
  ): RestResponse<SuccessResponse<GameDTO>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps/${game_id}/detail`,
      data: createOrUpdateGameRequest,
    });
  };

  const updateGame = (
    customer_id: string,
    game_id: string,
    createOrUpdateGameRequest: CreateOrUpdateGameRequest
  ): RestResponse<SuccessResponse<GameDTO>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/${customer_id}/apps/${game_id}/detail`,
      data: createOrUpdateGameRequest,
    });
  };

  const getGameDetailsById = (
    game_id: string
  ): RestResponse<SuccessResponse<GameDTO>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/customers/${game_id}/details`,
    });
  };

  const deleteGameByAdmin = (
    customer_id: string,
    game_id: string
  ): RestResponse<BaseResponse> => {
    console.log("game_id", game_id);
    return httpClient.request({
      method: "DELETE",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps/${game_id}`,
    });
  };

  const deleteGame = (
    customer_id: string,
    game_id: string
  ): RestResponse<BaseResponse> => {
    console.log("game_id", game_id);
    return httpClient.request({
      method: "DELETE",
      url: uriEncoding`api/v2/customers/${customer_id}/apps/${game_id}`,
    });
  };

  /**
   * HTTP POST /api/v2/admin/customers/{customer_id}/apps/{app_id}/credential
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.generateApiKey
   */
  const generateApiKey = (
    customer_id: string,
    app_id: string,
    secureHash?: string
  ): RestResponse<SuccessResponse<ApiKeyDetailsVO>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps/${app_id}/credential?secureHash=${secureHash}`,
    });
  };

  /**
   * HTTP GET /api/v2/admin/customers/{customer_id}/apps/{app_id}/credential
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.getApiKey
   */
  const getApiKey = (
    customer_id: string,
    app_id: string
  ): RestResponse<SuccessResponse<ApiKeyDetailsVO>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps/${app_id}/credential`,
    });
  };
  const generateAdminApiKey = (
    customer_id: string,
    app_id: string,
    secureHash?: string
  ): RestResponse<SuccessResponse<ApiKeyDetailsVO>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/${customer_id}/apps/${app_id}/credential?secureHash=${secureHash}`,
    });
  };

  /**
   * HTTP POST /api/v2/admin/customers/{customer_id}/apps/{app_id}/credential/revoke
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.revokeApiKey
   */
  const revokeApiKey = (
    customer_id: string,
    app_id: string,
    queryParams?: { secureHash?: string }
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/apps/${app_id}/credential/revoke`,
      data: queryParams,
    });
  };

  /**
   * HTTP POST /api/v2/admin/customers/{customer_id}/credential
   * Java method: d3.paas.admin.api.controller.CustomerController.updateCustomerCredential
   */
  const updateCustomerCredential = (
    customer_id: string
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/credential`,
    });
  };

  /**
   * HTTP GET /api/v2/admin/customers/{customer_id}/details
   * Java method: d3.paas.admin.api.controller.CustomerController.getCustomerDetailsById
   */
  const getCustomerDetailsById = (
    customer_id: string
  ): RestResponse<SuccessResponse<CustomerDTO>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/details`,
    });
  };

  const getAdminCustomerDetailsById = (
    customer_id: string
  ): RestResponse<SuccessResponse<CustomerDTO>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/customers/${customer_id}/details`,
    });
  };

  /**
   * HTTP PUT /api/v2/admin/customers/{customer_id}/details
   * Java method: d3.paas.admin.api.controller.CustomerController.updateCustomer
   */
  const updateCustomer = (
    customer_id: string,
    createOrUpdateCustomerRequest: CreateOrUpdateCustomerRequest
  ): RestResponse<SuccessResponse<CustomerDTO>> => {
    return httpClient.request({
      method: "PUT",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/details`,
      data: createOrUpdateCustomerRequest,
    });
  };

  /**
   * HTTP GET /api/v2/admin/customers/{customer_id}/services
   * Java method: d3.paas.admin.api.controller.CustomerController.getPlatFormServicesByCustomerId
   */
  const getPlatFormServicesByCustomerId = (
    customer_id: string
  ): RestResponse<SuccessResponse<PlatformServicesVO[]>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/services`,
    });
  };

  const getAdminPlatFormServicesByCustomerId = (
    customer_id: string
  ): RestResponse<SuccessResponse<PlatformServicesVO[]>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/customers/${customer_id}/services`,
    });
  };

  /**
   * HTTP PATCH /api/v2/admin/customers/{customer_id}/status
   * Java method: d3.paas.admin.api.controller.CustomerController.updateCustomerStatus
   */
  const updateCustomerStatus = (
    customer_id: string,
    queryParams: { status: boolean }
  ): RestResponse<SuccessResponse<CustomerDTO[]>> => {
    return httpClient.request({
      method: "PATCH",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/status`,
      data: queryParams,
    });
  };

  /**
   * HTTP POST /api/v2/admin/reports/customers
   * Java method: d3.paas.admin.api.controller.ReportsController.searchCustomerReport
   */
  const searchCustomerReport = (
    searchReportsRequest: SearchReportsRequest
  ): RestResponse<SuccessResponse<CustomerReportResponse>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/reports/customers`,
      data: searchReportsRequest,
    });
  };

  /**
   * HTTP POST /api/v2/admin/reports/users
   * Java method: d3.paas.admin.api.controller.ReportsController.searchUserReport
   */
  const searchUserReport = (
    userRole: string,
    customerAppId: string,
    searchReportsRequest: SearchReportsRequest
  ): any => {
    const url =
      userRole !== "admin"
        ? uriEncoding`api/v2/admin/reports/${customerAppId}/users`
        : uriEncoding`api/v2/customers/${customerAppId}/reports/users`;
    if (userRole && url && searchReportsRequest) {
      console.log("from service -> ", userRole, url, searchReportsRequest);
      return httpClient.request({
        method: "POST",
        url: url,
        data: { ...searchReportsRequest },
      });
    }
  };

  /**
   * HTTP GET /api/v2/admin/services
   * Java method: d3.paas.admin.api.controller.CustomerController.getAllPlatformServices
   */
  const getAllPlatformServices = (): RestResponse<
    SuccessResponse<PlatformServicesVO[]>
  > => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/services`,
    });
  };

  /**
   * HTTP GET /api/v2/static/countries
   * Java method: d3.paas.admin.api.controller.CustomerController.getAllCountryDetails
   */
  const getAllCountryDetails = (): RestResponse<
    SuccessResponse<CountryVO[]>
  > => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/static/countries`,
    });
  };

  /**
   * HTTP GET /api/v2/states/byCountry
   * Java method: d3.paas.admin.api.controller.CustomerController.getStateDetailsByCountry
   */
  const getStateDetailsByCountry = (queryParams: {
    countryId: string;
    restrictedStateStatus: string;
  }): RestResponse<SuccessResponse<StateVO[]>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/static/states/byCountry`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/static/states
   * Java method: d3.paas.admin.api.controller.CustomerController.getAllStateDetails
   */
  const getAllStateDetails = (queryParams: {
    restrictedStateStatus: string;
  }): RestResponse<SuccessResponse<StateVO[]>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/static/states`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/static/timezones
   * Java method: d3.paas.admin.api.controller.CustomerController.getAllTimezoneDetails
   */
  const getAllTimezoneDetails = (): RestResponse<
    SuccessResponse<TimeZonesVO[]>
  > => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/static/timezones`,
    });
  };

  /**
   * HTTP POST /api/v2/admin/subscriptions/plans
   * Java method: d3.paas.admin.api.controller.SubscriptionController.createSubscriptionsPlan
   */
  const createSubscriptionsPlan = (
    createSubscriptionPlanRequest: CreateSubscriptionPlanRequest
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/subscriptions/plans`,
      data: createSubscriptionPlanRequest,
    });
  };

  /**
   * HTTP GET /api/v2/admin/subscriptions/plans
   * Java method: d3.paas.admin.api.controller.SubscriptionController.getSubscriptionsPlans
   */
  const getSubscriptionsPlans = (): RestResponse<
    SuccessResponse<SubscriptionPlanVO[]>
  > => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/subscriptions/plans`,
    });
  };

  /**
   * HTTP DELETE /api/v2/admin/subscriptions/plans/{subscription_id}
   * Java method: d3.paas.admin.api.controller.SubscriptionController.deleteSubscriptionsPlans
   */
  const deleteSubscriptionsPlans = (
    subscription_id: string
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "DELETE",
      url: uriEncoding`api/v2/admin/subscriptions/plans/${subscription_id}`,
    });
  };

  /**
   * HTTP PATCH /api/v2/admin/subscriptions/plans/{subscription_id}/status
   * Java method: d3.paas.admin.api.controller.SubscriptionController.updateSubscriptionPlanStatus
   */
  const updateSubscriptionPlanStatus = (
    subscription_id: string
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "PATCH",
      url: uriEncoding`api/v2/admin/subscriptions/plans/${subscription_id}/status`,
    });
  };

  const addAdminFromSuperAdmin = (
    queryParams: {
      userFirstName: string;
      userLastName: string;
      userEmail: string;
    },
    customer_id: string
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/user`,
      data: queryParams,
    });
  };

  const addSuperAdminFromSuperAdmin = (queryParams: {
    userFirstName: string;
    userLastName: string;
    userEmail: string;
  }): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/user`,
      data: queryParams,
    });
  };

  const addAdminFromAdmin = (
    queryParams: {
      userFirstName: string;
      userLastName: string;
      userEmail: string;
    },
    customer_id: string
  ): RestResponse<SuccessResponse<any>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/${customer_id}/user`,
      data: queryParams,
    });
  };

  /**
   * HTTP POST api/v2/admin/user/${user_id}/updateSuperAdminUser
   * Java method: d3.paas.admin.api.controller.SuperCustomerController.updateSuperAdminUser
   */
  const updateSuperAdminFromSuperAdmin = (
    queryParams: {
      userFirstName: string;
      userLastName: string;
      userEmail: string;
    },
    user_id: string
  ): RestResponse<SuccessResponse<any>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/user/${user_id}/updateSuperAdminUser`,
      data: queryParams,
    });
  };

  /**
   * HTTP Delete api/v2/admin/user/{user_id}
   * Java method: d3.paas.admin.api.controller.SuperCustomerController.deleteSuperAdminUser
   */
  const deleteSuperAdminFromSuperAdmin = (
    user_id: string
  ): RestResponse<SuccessResponse<any>> => {
    return httpClient.request({
      method: "DELETE",
      url: uriEncoding`api/v2/admin/user/${user_id}`,
    });
  };

  /**
   * HTTP POST api/v2/admin/customers/{customer_id}/user/{user_id}/updateAdminUser
   * Java method: d3.paas.admin.api.controller.CustomerController.updateAdminUser
   */
  const updateAdminFromSuperAdmin = (
    queryParams: {
      userFirstName: string;
      userLastName: string;
      userEmail: string;
    },
    customer_id: string,
    user_id: string
  ): RestResponse<SuccessResponse<any>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/user/${user_id}/updateAdminUser`,
      data: queryParams,
    });
  };

  /**
   * HTTP Delete api/v2/admin/customers/{customer_id}/user/{user_id}
   * Java method: d3.paas.admin.api.controller.CustomerController.deleteAdminUser
   */
  const deleteAdminFromSuperAdmin = (
    customer_id: string,
    user_id: string
  ): RestResponse<SuccessResponse<any>> => {
    return httpClient.request({
      method: "DELETE",
      url: uriEncoding`api/v2/admin/customers/${customer_id}/user/${user_id}`,
    });
  };

  /**
   * HTTP POST api/v2/customers/{customer_id}/user/{user_id}/updateAdminUser
   * Java method: d3.paas.admin.api.controller.CustomerController.updateAdminUser
   */
  const updateAdminFromAdmin = (
    queryParams: {
      userFirstName: string;
      userLastName: string;
      userEmail: string;
    },
    customer_id: string,
    user_id: string
  ): RestResponse<SuccessResponse<any>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/${customer_id}/user/${user_id}/updateAdminUser`,
      data: queryParams,
    });
  };

  /**
   * HTTP Delete api/v2/customers/{customer_id}/user/{user_id}
   * Java method: d3.paas.admin.api.controller.CustomerController.deleteAdminUser
   */
  const deleteAdminFromAdmin = (
    customer_id: string,
    user_id: string
  ): RestResponse<SuccessResponse<any>> => {
    return httpClient.request({
      method: "DELETE",
      url: uriEncoding`api/v2/customers/${customer_id}/user/${user_id}`,
    });
  };

  /**
   * HTTP GET /api/v2/admin/superAdminUsers
   * Java method: d3.paas.admin.api.controller.UserController.getSuperAdminUser
   */
  const getSuperAdminUser = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
  }): RestResponse<SuccessResponse<PageResponseObject<UserInfoDTO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/superAdminUsers`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/admin/users
   * Java method: d3.paas.admin.api.controller.UserController.getUserByCustomerId
   */
  const getUserByCustomerId = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    customerId: string;
    roleName: string;
  }): RestResponse<SuccessResponse<PageResponseObject<UserInfoDTO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/users`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/customers/users
   * Java method: d3.paas.admin.api.controller.UserController.getUserByCustomerId
   */
  const getUserByCustomersId = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    customerId: string;
    roleName: string;
  }): RestResponse<SuccessResponse<PageResponseObject<UserInfoDTO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/customers/users`,
      data: queryParams,
    });
  };

  const getAdminUserByCustomerId = (queryParams: {
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    customerId: string;
  }): RestResponse<SuccessResponse<PageResponseObject<UserInfoDTO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/customers/users`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/admin/users/list
   * Java method: d3.paas.admin.api.controller.UserController.getAllUserList
   */
  const getAllUserList = (queryParams: {
    status: string;
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
  }): RestResponse<PageResponseObject<UserDTO[]>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/admin/users/list`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/admin/users/search
   * Java method: d3.paas.admin.api.controller.UserController.searchUsers
   */
  const searchUsers = (queryParams: {
    status: string;
    currentPage: number;
    itemPerPage: number;
    sortingOrder: string;
    sortingField: string;
    searchTerm: string;
  }): RestResponse<SuccessResponse<PageResponseObject<UserDTO[]>>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/users/search`,
      data: queryParams,
    });
  };

  /**
   * HTTP PATCH /api/v2/admin/users/{user_id}/status
   * Java method: d3.paas.admin.api.controller.UserController.updateUserStatus
   */
  const updateUserStatus = (
    user_id: string,
    queryParams: { status: boolean }
  ): RestResponse<SuccessResponse<UserDTO[]>> => {
    return httpClient.request({
      method: "PATCH",
      url: uriEncoding`api/v2/admin/users/${user_id}/status`,
      data: queryParams,
    });
  };

  /**
   * HTTP PATCH /api/v2/customers/users/{user_id}/status
   * Java method: d3.paas.admin.api.controller.UserController.updateUserStatus
   */
  const updateUserStatusByTenant = (
    user_id: string,
    queryParams: { status: boolean }
  ): RestResponse<SuccessResponse<UserDTO[]>> => {
    return httpClient.request({
      method: "PATCH",
      url: uriEncoding`api/v2/customers/users/${user_id}/status`,
      data: queryParams,
    });
  };
  /**
   * HTTP GET /api/v2/auth/changePassword
   * Java method: d3.paas.admin.api.controller.AuthenticationController.changePassword
   */
  const changePassword = (queryParams: {
    userName: string;
    oldPassword: string;
    newPassword: string;
  }): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/auth/changePassword`,
      data: queryParams,
    });
  };

  /**
   * HTTP POST /api/v2/auth/forgot/password
   * Java method: d3.paas.admin.api.controller.AuthenticationController.forgotPassword
   */
  const forgotPassword = (userName: string): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/auth/forgot/password?userName=${userName}`,
    });
  };

  /**
   * HTTP POST /api/v2/customers/apps/credential/refresh
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.refreshApiKey
   */
  const refreshApiKey = (queryParams: {
    customerId: string;
    customerAppId: string;
    secureHash?: string;
    apikey?: string;
  }): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/customers/apps/credential/refresh?customerId=${queryParams.customerId}&customerAppId=${queryParams.customerAppId}`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/auth/token/validate/{apiKeyId}
   * Java method: d3.paas.admin.api.controller.AccessKeyValidatorController.validateToken
   */
  const validateToken = (apiKeyId: string): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/auth/token/validate/${apiKeyId}`,
    });
  };

  /**
   * HTTP GET /api/v2/customers/{customer_id}/credential
   * Java method: d3.paas.admin.api.controller.CustomerAppsController.getCustomerCredential
   */
  const getCustomerCredential = (
    customer_id: string
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/customers/${customer_id}/credential`,
    });
  };

  /**
   * HTTP POST /api/v2/users
   * Java method: d3.paas.admin.api.controller.UserController.createUserWallet
   */
  const createUserWallet = (
    createUserRequest: CreateUserRequest
  ): RestResponse<SuccessResponse<UserDTO[]>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/users`,
      data: createUserRequest,
    });
  };

  /**
   * HTTP GET /api/v2/users/{user_id}/details
   * Java method: d3.paas.admin.api.controller.UserController.getUserDetailsById
   */
  const getUserDetailsById = (
    user_id: string
  ): RestResponse<SuccessResponse<UserDTO>> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/users/${user_id}/details`,
    });
  };

  /**
   * HTTP POST /api/v2/auth/login
   * Java method: d3.paas.admin.api.controller.AuthenticationController.userLogin
   */
  const userLogin = (
    loginRequest: LoginRequest
  ): RestResponse<SuccessResponse<LoginResponse>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/auth/login`,
      data: loginRequest,
    });
  };

  /**
   * HTTP POST /api/v2/auth/logout
   * Java method: d3.paas.admin.api.controller.AuthenticationController.userLogout
   */
  const userLogout = (): RestResponse<SuccessResponse<string>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/auth/logout`,
    });
  };

  /**
   * HTTP GET /api/v2/auth/reset
   * Java method: d3.paas.admin.api.controller.AuthenticationController.resetPassword
   */
  const resetPassword = (queryParams: {
    userName: string;
    oldPassword: string;
    newPassword: string;
  }): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/auth/reset`,
      data: queryParams,
    });
  };

  /**
   * HTTP GET /api/v2/users/{user_id}/location
   * Java method: d3.paas.admin.api.controller.UserController.verifyUserLocation
   */
  const verifyUserLocation = (
    user_id: string,
    location: LocationVO
  ): RestResponse<boolean> => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/users/${user_id}/location`,
      data: location,
    });
  };

  /**
   * HTTP POST /api/v2/wallets/transactions/{customer_id}/walletChart
   * Java method: d3.paas.admin.api.controller.WalletTransactionController.getWalletChartReport
   */
  const getWalletChartReport = (
    customerId: string | null,
    searchReportsRequest: WalletChartRequest
  ): RestResponse<SuccessResponse<WalletChartResponse>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/wallets/transactions/walletChart/${customerId}`,
      data: searchReportsRequest,
    });
  };

  /**
   * HTTP POST /api/v2/payments/reports/{customer_id}/income
   * Java method: d3.paas.billing.api.v2.rest.controller
   */
  const getIncomeChart = (
    customer_id: string | null,
    searchReportsRequest: IncomeSearchReportsRequest
  ): RestResponse<SuccessResponse<IncomeReportsResponse>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/payments/reports/${customer_id}/income`,
      data: searchReportsRequest,
    });
  };

  /**
   * HTTP POST /api/v2/wallets/transactions/challengeChart/{customer_id}
   * Java method: d3.paas.admin.api.controller.WalletTransactionController.getChallengeChart
   */
  const getChallengeChart = (
    customer_id: string | null,
    challengeChartRequest: ChallengeChartRequest
  ): RestResponse<SuccessResponse<ChallengeChartResponse>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/wallets/transactions/challengeChart/${customer_id}`,
      data: challengeChartRequest,
    });
  };

  const getAllGames = (
    customerId: any
  ): any => {
    return httpClient.request({
      method: "GET",
      url: uriEncoding`api/v2/customers/apps/allGames`,
      data: customerId
    });
  };

  /**
  * HTTP POST api/v2/users/setup2fa
  * Java method: d3.paas.admin.api.controller.UserController.setupTwoFactorAuth
  */
  const setupTwoFactorAuth = (userEmail: string): RestResponse<SuccessResponse<string>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/users/setup2fa?userEmail=${userEmail}`,
    });
  };

  /**
   * HTTP POST api/v2/users/verifyOtp
   * Java method: d3.paas.admin.api.controller.UserController.verifyOTP
   */
  const verifyOTP = (userEmail: string, otpCode: number): RestResponse<SuccessResponse<OTPVerificationResponse>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/users/verifyOtp?userEmail=${userEmail}&otpCode=${otpCode}`,
    });
  };

  /**
 * HTTP POST api/v2/users/verifyBackupCode
 * Java method: d3.paas.admin.api.controller.UserController.verifyBackupCode
 */
  const verifyBackupCode = (userEmail: string, backupCode: string): RestResponse<SuccessResponse<BackupCodeVerificationResponse>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/users/verifyBackupCode?userEmail=${userEmail}&backupCode=${backupCode}`,
    });
  };

  /**
* HTTP POST api/v2/admin/users/reset2fa
* Java method: d3.paas.admin.api.controller.UserController.reset2fa
*/
  const reset2fa = (userEmail: string): RestResponse<SuccessResponse<string>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/users/reset2fa?userEmail=${userEmail}`,
    });
  };

  /**
    * HTTP POST /api/v2/admin/reports/adminActivity
    * Java method: d3.paas.admin.api.controller.ReportsController.getAdminActivityReport
    */
  const getAdminActivityReport = (requestBody: AuditEventRequest): RestResponse<SuccessResponse<PageResponseObject<AdminActivityReportResponse[]>>> => {
    return httpClient.request({
      method: "POST",
      url: uriEncoding`api/v2/admin/reports/adminActivity`,
      data: requestBody,
    });
  };

   /**
   * HTTP PATCH /api/v2/users/preferences/theme
   * Java method: d3.paas.admin.api.controller.UserController.updateThemeMode
   */
  const updateThemeMode = (
    queryParams: { themeMode: string }
  ): RestResponse<BaseResponse> => {
    return httpClient.request({
      method: "PATCH",
      url: uriEncoding`api/v2/users/preferences/theme`,
      data: queryParams,
    });
  };

  /**
 * HTTP POST /api/v2/admin/users/getUserCountByTenantIds
 * Java method: d3.paas.admin.api.controller.UserController.getUserCountByTenantIds
 */
const getUserCountByTenantIds = (
  tenantIds: string[]
): RestResponse<SuccessResponse<UserCountResponse[]>> => {
  return httpClient.request({
    method: "POST",
    url: uriEncoding`api/v2/users/getUserCountByTenantIds`,
    data: tenantIds,
  });
};

  return {
    addAdminFromSuperAdmin,
    addSuperAdminFromSuperAdmin,
    addAdminFromAdmin,
    createAdminCustomerApp,
    generateAdminApiKey,
    getAdminUserByCustomerId,
    getAdminCustomerAppsById,
    getAdminPlatFormServicesByCustomerId,
    getAdminCustomerDetailsById,
    changePassword,
    forgotPassword,
    refreshApiKey,
    validateToken,
    getCustomerAppsNameByAppIds,
    userLogin,
    userLogout,
    resetPassword,
    getCustomerAppDetailsByAppIds,
    createCustomer,
    getCustomerDetailsByIds,
    getAllCustomerDetails,
    searchCustomer,
    updateCustomerAppStatus,
    createCustomerApp,
    getCustomerAppsById,
    generateApiKey,
    getApiKey,
    revokeApiKey,
    updateCustomerCredential,
    getCustomerDetailsById,
    updateCustomer,
    getPlatFormServicesByCustomerId,
    updateCustomerStatus,
    getAllCountryDetails,
    getStateDetailsByCountry,
    getAllPlatformServices,
    getAllStateDetails,
    getAllTimezoneDetails,
    createSubscriptionsPlan,
    getSubscriptionsPlans,
    deleteSubscriptionsPlans,
    updateSubscriptionPlanStatus,
    getUserByCustomerId,
    getUserByCustomersId,
    getAllUserList,
    searchUsers,
    updateUserStatus,
    searchCustomerReport,
    searchUserReport,
    getCustomerCredential,
    createUserWallet,
    getUserDetailsById,
    verifyUserLocation,
    getAdminGamesByAppsId,
    createGame,
    createGameByAdmin,
    updateGame,
    updateGameByAdmin,
    getGameDetailsById,
    deleteGame,
    deleteGameByAdmin,
    getCustomerGamesByAppId,
    approveGame,
    getSuperAdminUser,
    updateSuperAdminFromSuperAdmin,
    deleteSuperAdminFromSuperAdmin,
    updateAdminFromSuperAdmin,
    deleteAdminFromSuperAdmin,
    updateAdminFromAdmin,
    deleteAdminFromAdmin,
    getWalletChartReport,
    getIncomeChart,
    getChallengeChart,
    getAllGames,
    setupTwoFactorAuth,
    verifyOTP,
    verifyBackupCode,
    reset2fa,
    updateUserStatusByTenant,
    getAdminActivityReport,
    updateThemeMode,
    getUserCountByTenantIds
  };
}

export type RestResponse<R> = Promise<R>;

export const enum AccessTokenType {
  APIKEY = "APIKEY",
  USERKEY = "USERKEY",
}

export const enum ActionEnum {
  CREATE = "CREATE",
  UPDATE = "UPDATE",
  DELETE = "DELETE",
  STATUS_CHANGE = "STATUS_CHANGE",
}

export const enum ApiKeyStatusEnums {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
  REVOKE = "REVOKE",
  EXPIRE = "EXPIRE",
}

export const enum CacheType {
  SESSION_CACHE = "SESSION_CACHE",
}

export const enum CreationStatus {
  CREATED = "CREATED",
  ALREADY_CREATED = "ALREADY_CREATED",
  REJECTED = "REJECTED",
}

export const enum EntityTypeEnum {
  USER = "USER",
  WALLET = "WALLET",
  CUSTOMER = "CUSTOMER",
}

export const enum TransactionSubType {
  REDEEM = "REDEEM",
  PURCHASE = "PURCHASE",
  SETTLE = "SETTLE",
  INITIAL_TOPUP = "INITIAL_TOPUP",
  RESERVE = "RESERVE",
  REVERT = "REVERT",
  LOYALTY_BONUS = "LOYALTY_BONUS",
  REDEEM_TOKENS = "REDEEM_TOKENS",
  ADMIN_FEES = "ADMIN_FEES",
}

export const enum UserRoleTypes {
  SUPER_ADMIN = "SUPER_ADMIN",
  ADMIN = "ADMIN",
  USER = "USER",
}

export const enum WalletTypeEnum {
  USER = "USER",
  TENANT = "TENANT",
  SUPER_ADMIN = "SUPER_ADMIN",
}

export const enum SortingField {
  lastModifiedOn = "lastModifiedOn",
  createdOn = "createdOn",
}

export const enum Direction {
  ASC = "ASC",
  DESC = "DESC",
}

function uriEncoding(
  template: TemplateStringsArray,
  ...substitutions: any[]
): string {
  let result = "";
  for (let i = 0; i < substitutions.length; i++) {
    result += template[i];
    result += encodeURIComponent(substitutions[i]);
  }
  result += template[template.length - 1];
  return result;
}
